import { Outlet } from "react-router";
import { AccountMenu } from "@/routes/app/AccountMenu";
import { ListScopeNav } from "@/routes/app/lists/ListScopeNav";
import { Logo } from "@/shared/components/ui/Logo";

/**
 * Protected /app/* shell.
 *
 * Desktop (`lg:` and up): top bar with three slots — Logo (left),
 * `ListScopeNav` (centered: scope chip + add/manage icon buttons),
 * `AccountMenu` (right).
 *
 * Mobile (`<lg`): top bar collapses to Logo + AccountMenu; the
 * `ListScopeNav` group moves to a bottom-fixed dock and respects the iOS
 * safe-area inset so it floats above the home indicator.
 *
 * The header itself is fully transparent (no fill, blur, or shadow) so
 * the bar dissolves into the page canvas — only the logo, scope chip +
 * buttons, and account avatar read as nav chrome. See design.md §8.
 *
 * No Framer Motion is imported anywhere in /app/* per design.md §12 —
 * any hover/active transitions are CSS-only on the chips.
 */
export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-surface">
      <header className="sticky top-0 z-tooltip">
        <div className="flex h-16 items-center justify-between gap-4 px-6 lg:grid lg:h-20 lg:grid-cols-[1fr_auto_1fr] lg:px-10">
          <div className="flex items-center">
            <Logo variant="mark" className="lg:hidden" />
            <Logo variant="full" className="hidden lg:block" />
          </div>
          <div className="hidden justify-center lg:flex">
            <ListScopeNav />
          </div>
          <div className="flex items-center justify-end">
            <AccountMenu />
          </div>
        </div>
      </header>

      <main className="flex-1 pb-28 lg:pb-12">
        <Outlet />
      </main>

      <div
        className="fixed inset-x-0 bottom-0 z-tooltip flex px-4 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] pt-2 lg:hidden"
        aria-hidden={false}
      >
        <ListScopeNav className="w-full" />
      </div>
    </div>
  );
}
